import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Property, PropertyType, PropertyStatus, TransactionType } from '../models/property';
import { PdfService } from '../services/pdf.service';

@Component({
    selector: 'app-property-detail-dialog',
    templateUrl: './property-detail-dialog.component.html',
    styleUrls: ['./property-detail-dialog.component.css']
})
export class PropertyDetailDialogComponent implements OnInit {

    property: Property;
    dateNow: Date = new Date();
    exportingPdf: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<PropertyDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { property: Property },
        private pdfService: PdfService
    ) {
        this.property = data.property;
    }

    ngOnInit(): void {
    }

    onClose(): void {
        this.dialogRef.close();
    }

    getStatusColor(status: PropertyStatus): string {
        const colors: { [key: string]: string } = {
            'disponible': 'green',
            'loue': 'blue',
            'vendu': 'purple',
            'reserve': 'orange',
            'indisponible': 'red',
            'en_negociation': 'yellow'
        };
        return colors[status] || 'gray';
    }

    getTypeLabel(type: PropertyType): string {
        const labels: { [key: string]: string } = {
            'appartement': 'Appartement',
            'maison': 'Maison',
            'terrain': 'Terrain',
            'bureau': 'Bureau',
            'local_commercial': 'Local Commercial',
            'villa': 'Villa',
            'studio': 'Studio',
            'duplex': 'Duplex',
            'penthouse': 'Penthouse'
        };
        return labels[type] || type;
    }

    getTransactionTypeLabel(type: TransactionType): string {
        const labels: { [key: string]: string } = {
            'location': 'Location',
            'vente': 'Vente',
            'location_vente': 'Location/Vente'
        };
        return labels[type] || type;
    }

    formatPrice(price: number): string {
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'XOF'
        }).format(price);
    }

    formatDate(date: any): string {
        if (!date) return 'N/A';
        return new Date(date).toLocaleDateString('fr-FR');
    }

    getEnergyClassColor(energyClass: string): string {
        const colors: { [key: string]: string } = {
            'A': '#2e7d32',
            'B': '#4caf50',
            'C': '#8bc34a',
            'D': '#ffeb3b',
            'E': '#fbc02d',
            'F': '#f57c00',
            'G': '#d32f2f'
        };
        return colors[energyClass] || '#9e9e9e';
    }

    getGesClassColor(gesClass: string): string {
        const colors: { [key: string]: string } = {
            'A': '#e1f5fe',
            'B': '#b3e5fc',
            'C': '#81d4fa',
            'D': '#4fc3f7',
            'E': '#29b6f6',
            'F': '#03a9f4',
            'G': '#0288d1'
        };
        return colors[gesClass] || '#9e9e9e';
    }

    openUrl(url: string | undefined): void {
        if (url) {
            window.open(url, '_blank');
        }
    }

    exportPdf(): void {
        this.exportingPdf = true;
        const fileName = `Fiche_Bien_${this.property.reference || this.property.id}`;

        // Wait for Angular to update the DOM (hide tabs, show printable container)
        setTimeout(() => {
            const promise = this.pdfService.generatePdf('property-pdf-content', fileName);

            if (promise && typeof promise.then === 'function') {
                promise.then(() => {
                    this.exportingPdf = false;
                }).catch((err: any) => {
                    console.error('PDF generation error', err);
                    this.exportingPdf = false;
                });
            } else {
                // Fallback timeout in case promise isn't supported correctly
                setTimeout(() => { this.exportingPdf = false; }, 3000);
            }
        }, 400); // Allow UI to render the new state
    }
}
